
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { InsightCard as InsightCardType } from "@/types/insight";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ChartBarIcon, ArrowRight } from "lucide-react";

interface PollRelatedInsightsProps {
  cards: InsightCardType[];
}

const PollRelatedInsights = ({ cards }: PollRelatedInsightsProps) => {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Related Insight Cards</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {cards.map(card => (
          <Card key={card.id} className="overflow-hidden transition-all hover:shadow-md">
            <CardContent className="p-4">
              <div className="flex flex-col space-y-2">
                <div className="flex justify-between items-start">
                  <h3 className="font-medium text-lg">{card.title}</h3>
                  <Badge className="bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100">
                    <ChartBarIcon className="h-3.5 w-3.5 mr-1" />
                    {card.agreePercentage}% Agree
                  </Badge>
                </div>
                
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {card.description.length > 150 
                    ? `${card.description.substring(0, 150)}...` 
                    : card.description}
                </p>
                
                <div className="pt-2">
                  <Link 
                    to={`/insight/${card.slug}`}
                    className="text-blue-600 dark:text-blue-400 text-sm font-medium flex items-center hover:underline"
                  >
                    View Insight <ArrowRight className="ml-1 h-4 w-4" />
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default PollRelatedInsights;
